/* MOKIPOPS Pop — media picker feed client */
(function () {
  var BASE = 'https://borngifted.github.io/mokipops-reel/';
  var cachePromise = null;

  function fetchJson(url) {
    var attempt = function (n) {
      var ctl = new AbortController();
      var timer = setTimeout(function () { ctl.abort(); }, 3000);
      return fetch(url, { signal: ctl.signal })
        .then(function (res) {
          clearTimeout(timer);
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .catch(function (err) {
          clearTimeout(timer);
          if (n > 0) return attempt(n - 1);
          console.warn('[mp-pop] fetch failed:', url, err.message);
          return null;
        });
    };
    return attempt(1);
  }

  function load() {
    if (!cachePromise) {
      cachePromise = Promise.all([
        fetchJson(BASE + 'storefront-feed.json'),
        fetchJson(BASE + 'assets/library/library-data.json'),
      ]).then(function (results) {
        var feed = results[0];
        var manifest = results[1];
        if (!feed || !manifest || !manifest.items) return null;
        var byId = new Map();
        manifest.items.forEach(function (item) { byId.set(item.id, item); });
        return { feed: feed, manifest: manifest, byId: byId };
      });
    }
    return cachePromise;
  }

  function absUrl(u) {
    if (!u) return '';
    return /^https?:/.test(u) ? u : BASE + u;
  }

  function resolve(channel) {
    return load().then(function (data) {
      if (!data || !data.feed.channels) return [];
      var entries = data.feed.channels[channel] || [];
      return entries
        .map(function (entry) {
          if (typeof entry === 'string') return data.byId.get(entry);
          if (entry && entry.mediaUrl) return entry; // direct media object (e.g. Facebook post)
          return null;
        })
        .filter(Boolean);
    });
  }

  /* A feed row can hold a dozen clips. Decoding them all at once locks the
     main thread, so tiles only play while they are actually on screen. */
  var playWatcher = null;
  function watchPlayback(video) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) {
      video.play().catch(function () {});
      return;
    }
    if (!playWatcher) {
      playWatcher = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var el = entry.target;
          if (entry.isIntersecting) {
            if (el.preload !== 'auto') el.preload = 'auto';
            el.play().catch(function () {});
          } else if (!el.paused) {
            el.pause();
          }
        });
      }, { rootMargin: '100px', threshold: 0.1 });
    }
    playWatcher.observe(video);
  }

  function mediaCard(item) {
    // Feed items sourced from a real post link back to it; everything else
    // stays a plain div so nothing renders as a dead link.
    var card = document.createElement(item.postUrl ? 'a' : 'div');
    card.className = 'mp-media-card';
    if (item.postUrl) {
      card.href = item.postUrl;
      card.target = '_blank';
      card.rel = 'noopener';
      if (item.title) card.setAttribute('aria-label', item.title);
    }
    if (item.mediaType === 'video') {
      var video = document.createElement('video');
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('muted', '');
      // No autoplay attribute: watchPlayback drives play/pause by visibility.
      // preload none keeps off-screen tiles from fetching until they matter —
      // the poster carries the tile until then.
      video.preload = 'none';
      if (item.thumbnail) video.poster = absUrl(item.thumbnail);
      video.src = absUrl(item.mediaUrl);
      video.addEventListener('error', function () {
        if (!video.poster) return;
        var img = document.createElement('img');
        img.loading = 'lazy';
        img.alt = item.title || '';
        img.src = video.poster;
        card.innerHTML = '';
        card.appendChild(img);
      });
      card.appendChild(video);
      watchPlayback(video);
    } else {
      var img = document.createElement('img');
      img.loading = 'lazy';
      img.alt = item.title || '';
      img.src = absUrl(item.thumbnail || item.mediaUrl);
      card.appendChild(img);
    }
    return card;
  }

  window.MPFeed = { load: load, resolve: resolve, mediaCard: mediaCard, absUrl: absUrl };

  /* Site-wide fruit parallax: any [data-mp-depth] element drifts relative to
     its host section as it moves through the viewport. */
  function initParallax() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var floaters = Array.prototype.slice.call(document.querySelectorAll('[data-mp-depth]'));
    if (!floaters.length) return;
    var items = floaters.map(function (el) {
      return { el: el, host: el.parentElement, depth: parseFloat(el.dataset.mpDepth || '0.2') };
    });
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      items.forEach(function (item) {
        var rect = item.host.getBoundingClientRect();
        if (rect.bottom < -200 || rect.top > vh + 200) return;
        var offset = (rect.top + rect.height / 2 - vh / 2) * item.depth;
        item.el.style.transform = 'translateY(' + offset.toFixed(1) + 'px)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initParallax);
  } else {
    initParallax();
  }
})();
